const SET_USERS = (state, users) => {
  state.users = users;
};

const CACHE_USER = (state, user) => {
  const index = state.usersCache.findIndex((u) => u.id === user.id);

  if (index !== -1) {
    state.usersCache.splice(index, 1);
  }

  state.usersCache.push(user);
};

const CACHE_USERS = (state, users) => {
  users.forEach((user) => {
    // If the user already exists in the usersCache array, remove it and replace it with the new
    // user value
    const index = state.usersCache.findIndex((u) => u.id === user.id);

    if (index !== -1) {
      state.usersCache.splice(index, 1);
    }

    state.usersCache.push(user);
  });
};

const SET_FETCHING_USERS = (state, value) => {
  state.fetchingUsers = value;
};

const SET_FETCHING_USER_IDS = (state, userIds) => {
  // Add the userIds to the fetchingUsersIds array which don't already exist in the array
  userIds.forEach((userId) => {
    if (state.fetchingUsersIds.indexOf(userId) === -1) {
      state.fetchingUsersIds.push(userId);
    }
  });
};

const UNSET_FETCHING_USER_IDS = (state, userIds) => {
  // Unset the userIds from the fetchingUsersIds array
  userIds.forEach((userId) => {
    const index = state.fetchingUsersIds.indexOf(userId);

    if (index !== -1) {
      state.fetchingUsersIds.splice(index, 1);
    }
  });
};

export default {
  SET_USERS,
  SET_FETCHING_USERS,
  CACHE_USER,
  CACHE_USERS,
  SET_FETCHING_USER_IDS,
  UNSET_FETCHING_USER_IDS,
};
